<template>
  <section class="mx-3 lg:mx-0 max-w-screen-2xl">
    <div
      class="md:w-441px lg:ml-16 user-card p-4 flex flex-col text-black-2 font-normal text-xs md:text-sm bg-center"
    >
      <div v-if="!isLoading">
        <div
          class="justify-start py-2 px-2 w-full flex font-normal text-lg text-root-2"
        >
          {{
            hasLimitedSettings
              ? 'TORUSMARA TERMS OF SERVICE'
              : 'Deposit Agreement'
          }}
        </div>
        <div
          @click="showDialog = true"
          class="bg-gray-30 border border-gray-12 cursor-pointer md:flex justify-between px-4 mx-2 my-2 mb-6 py-4 rounded-xl overflow-y-scroll h-60"
        >
          <div class="font-normal">
            <div v-if="hasLimitedSettings">
              <torus-mara-contract />
            </div>
            <div v-else><agreement-contract /></div>
          </div>
        </div>
        <div
          @click="showDialog = true"
          class="border border-primary cursor-pointer font-semibold hover:opacity-80 flex text-primary items-center md:justify-start justify-center py-2 mx-10 rounded-full"
        >
          <span class="md:mr-24 md:ml-4"><download-icon /></span>
          Download
        </div>
      </div>
      <div v-else class="mt-10 mb-4">
        <spinner
          size="medium"
          :spacing="40"
          message=""
          :line-fg-color="$primaryColor"
        />
      </div>
    </div>
    <contract-details-dialog
      v-if="showDialog"
      :showDialog="showDialog"
      @closeDialog="closeDialog"
    />
  </section>
</template>

<script>
export default {
  data () {
    return {
      showDialog: false,
      isLoading: false,
      showDetailsDialog: false
    }
  },
  methods: {
    closeDialog () {
      this.showDialog = false
    },
    back () {
      this.$emit('goBack')
    },
    async getContract () {
      this.isLoading = true
      await this.$store
        .dispatch('transactions/depositAgreement')
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    goBack () {
      this.$router.push('/settings')
    }
  },
  components: {
    DownloadIcon: () => import('@/assets/icons/DownloadIcon.vue'),
    ContractDetailsDialog: () =>
      import('@/components/settings/ContractDetailsDialog.vue'),
    TorusMaraContract: () =>
      import('@/components/settings/TorusMaraContract.vue'),
    AgreementContract: () =>
      import('@/components/settings/AgreementContract.vue')
  },
  computed: {
    agreementContract () {
      const depositAgreement = this.$store.state.transactions.depositContract
      if (depositAgreement) {
        return depositAgreement
      }
      return null
    },
    hasLimitedSettings () {
      return process.env.VUE_APP_SETTINGS_LIMITED === 'true'
    }
  }
}
</script>
<style scoped>
.user-card {
  background: var(--background);
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}
</style>
